export default {
    NONE: 0,
    EXISTING: 1,
    NEW: 2,
    0: 'None',
    1: 'Existing',
    2: 'New'
};